// import dJSON from 'dirty-json';
// import '../node_modules/@lottiefiles/lottie-player/dist/lottie-player';

import './js/base/base-start';
import './js/global';

// modules - core
import './modules/core/accordion/module';

// modules
import './modules/evox/header-info/module';
import './modules/evox/topbar-2/module';
import './modules/evox/header-3/module';
import './modules/evox/megamenu-3/module';
import './modules/evox/menu-2/module';
import './modules/evox/sticky-header/module';
import './modules/evox/footer-1/module';
import './modules/evox/footer-bottom/module';
import './modules/evox/custom-contact/module';

import './modules/theme/about-us-1/module';
import './modules/theme/call-to-action-3/module';
import './modules/theme/who-we-serve/module';
import './modules/theme/category-section-3/module';
import './modules/theme/hero-1/module';
import './modules/theme/whats-new/module';
import './modules/theme/testimonials-3/module';
import './modules/theme/static-hero/module';
import './modules/theme/request-account/module';

// layouts

// leave me last
import './js/base/base-end';
